import Signal from "libs/signals";

const attachDocumentsModalSignal = Signal({
  selectedTemplateDocument: null,
  selectedDataRoomDocuments: [],
  modalVisible: null,
});

export default attachDocumentsModalSignal;
